import AppNavbar from "./components/Navbar.vue";
import AppMain from "./components/Main.vue";
import AppInfo from "./components/Info.vue";
import AppExperience from "./components/Experience.vue";
import AppContact from "./components/Contact.vue";
import AppFooter from "./components/Footer.vue";

export const routes = [
  {
    path: "",
    components: {
      navbar: AppNavbar,
      default: AppMain,
      info: AppInfo,
      experience: AppExperience,
      contact: AppContact,
      footer: AppFooter
    }
  },
  { path: '*', redirect: '/' }
];



// WEBPACK FOOTER //
// ./src/routes.js